import React, { useEffect } from "react";

// MATERIAL UI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { LightGreyBox } from "../../styled";
import { StyledGreyBadge } from "../../styled/badge";

// ICONS
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import { formatFinance } from "../../../utils/formatters";

const BeautifiedOrderProductsJsonBody = ({ jsonBody, createdBy }) => {
  useEffect(() => {
    console.log(jsonBody);
  }, []);

  return (
    <LightGreyBox>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <ProductionQuantityLimitsIcon />
      </Box>
      {jsonBody.map((item, index) => (
        <Stack key={index} spacing={1}>
          {item.title && (
            <StyledGreyBadge>
              <Typography variant="subtitle1" align="center" fontWeight="bold">
                {item.title} x {item.quantity} ={" "}
                {formatFinance(parseFloat(item.total_price))}
              </Typography>
            </StyledGreyBadge>
          )}
          {item.complements &&
            item.complements.map((complement, cIndex) => (
              <div key={cIndex}>
                {complement.title && (
                  <Typography variant="subtitle2" align="center">
                    Complemento: {complement.title}
                  </Typography>
                )}
                <Typography variant="subtitle2" align="center">
                  Quantidade: {complement.quantity}
                </Typography>
                <Typography variant="subtitle2" align="center">
                  Preço: {complement.price || complement.complement_price}
                </Typography>
              </div>
            ))}
        </Stack>
      ))}
      <Divider sx={{ my: 2 }} />
      <Typography variant="subtitle1" align="center">
        Modificado Por: {createdBy}
      </Typography>
    </LightGreyBox>
  );
};

export default BeautifiedOrderProductsJsonBody;
